import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { trackEvent } from '../../../hooks/useGoogleAnalytics';

const FeaturedServiceCard = ({ service }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    trackEvent('Service', 'Click', service?.name);
    navigate(`/digital-service-standee?service=${service?.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="group bg-card rounded-xl overflow-hidden border border-border hover:shadow-lg transition-all duration-300 cursor-pointer"
    >
      <div className="relative h-48 overflow-hidden">
        <Image
          src={service?.imageUrl}
          alt={service?.imageAlt || `${service?.name} service`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {service?.isFeatured && (
          <div className="absolute top-4 left-4 bg-accent text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
            <Icon name="Star" size={14} />
            Featured
          </div>
        )}
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-semibold text-primary uppercase tracking-wide">
            {service?.category?.name || 'Service'}
          </span>
          <div className="flex items-center gap-1">
            <Icon name="Star" size={14} className="text-accent fill-accent" />
            <span className="text-sm font-semibold text-foreground">
              {service?.avgRating?.toFixed(1) || '0.0'}
            </span>
            <span className="text-xs text-muted-foreground">({service?.reviewCount || 0})</span>
          </div>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-1">
          {service?.name}
        </h3>
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {service?.description}
        </p>
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">
              {service?.partnerCount || 0} providers
            </span>
          </div>
          <div className="text-lg font-bold text-foreground">
            {service?.avgPrice || 'Contact for pricing'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedServiceCard;